export class Ic3GlobalClasses {

    static readonly singleSelection = 'ic3-SingleSelection';

    static readonly multipleSelection = 'ic3-MultipleSelection';
}

